<template>
  <div style="margin-top:-71px;">
    <v-container fluid>
      <v-row style="" justify="space-around" class="white--text">
        <v-col cols="6" class="">
          <v-row justify="center">
            <v-img
              src="@/assets/avabot/avabot-header.jpg"
              style="border-radius: 0 0 50px 0;"
            ></v-img>
          </v-row>
        </v-col>
        <v-col cols="6" class="text-center" style="margin-top:80px">
          <div style="" class="">
            <h2 class="text-h3  ">
              A First Stage <br />
              Teleoperations <br />
              Robotic System
            </h2>
            <p class="text-h5 mt-5 text">
              Project For:<br />
              <v-row justify="center">
                <h3 class="text-h5">Broad Core</h3>
                <!-- <v-img
                  src="@/assets/pillbottle/johnnyfive.png"
                  max-width="150px"
                ></v-img> -->
              </v-row>
              ....under construction
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>

    <!-- <v-row justify="center" class="white--text  py-16" style="margin-top:170px">
      <div style="max-width: 900px;">
        <h2 class="text-h3 text-center">What We Do</h2>
        <p class="text-h5 mt-3 text-center">
          We create innovative digital and physical products by using virtual
          tools to design, create and solve the problems of today and tomorrow.
          Through the use of extended reality, embedded systems and the spatial
          web we can create new solutions, processes, and innovations. And by
          integrating blockchain based distribution and fair value exchange
          create better and more effective forms of collaboration.
          <br />
        </p>
      </div>
    </v-row> -->
    <v-container style="max-width:1200px; margin-top:100px;">
      <v-row style="" justify="space-around" class="white--text">
        <v-col cols="12" class="text-center">
          <h2 class="text-h3 mt-5">
            Video Introduction
          </h2>
        </v-col>
        <v-col cols="12" class="">
          <v-row justify="center">
            <iframe
              width="700"
              height="394"
              src="https://www.youtube.com/embed/K_x-ldMsSEM"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <!-- <v-container style="max-width:1200px">
      <v-row class="white--text  py-16 mt-16">
        <v-col cols="6">

          <v-img
            src="@/assets/virtue-virtual.jpg"
            style="border-radius:50%;"
            width="85%"
          ></v-img>

        </v-col>
        <v-col cols="6" class="mt-16">
          <h2 class="text-h3 text-right mt-6">
            Bringing Virtue To The Virtual
          </h2>
          <p class="text-h5 mt-3 text-right">
            All we do is done with a greater goal to move into a global resource
            sharing and collaboration based economic system. Based on virtue to
            overcome the crisis and challenges of our current economic and
            social system.
          </p>
          <v-row justify="end">
            <v-img src="@/assets/tech.png"></v-img>
          </v-row>
        </v-col>
        <v-col cols="12" class="mt-n2"> </v-col>
      </v-row>
    </v-container> -->
    <!-- if making first div absolute position wrap rest of content into this -->
    <!-- <div style="position:absolute; top:100vh; width:100%;"> -->
    <div style="background:#01000A;">
      <!-- <v-container style="max-width:1300px">
        <v-row justify="center" style="margin-top:180px;">
          <h2 class="white--text text-h3 text-center">Core Technologies</h2>
        </v-row>
        <v-row class="white--text mt-16">
          <v-col cols="6" class="mt-16">
            <v-row justify="center" class="mt-16">
              <v-img src="@/assets/spatial-web-virtue.png"></v-img>
            </v-row>
          </v-col>
          <v-col cols="6 mt-15">
            <h2 class="text-h3 mt-16">The Spatial Web</h2>
            <p class="text-h5 mt-3" style="max-width:540px;">
              The Spatial Web is a new emerging frontier that is changing how we
              interact with the internet and technology around us. It gives us
              the ability to merge the real three dimensional world with the
              virtual one. By combining smart sensor based environments with
              augmented and virtual reality we can create virtualized copies of
              the world and use it to meet, share and collabore accross the
              globe
            </p>
          </v-col>
        </v-row>
      </v-container> -->
      <!-- <v-container fluid>
        <v-row justify="center" style="margin-top:200px;">
          <v-img
            src="@/assets/blockchain-network.png"
            max-width="750px"
          ></v-img>
        </v-row>
        <v-row
          justify="space-around"
          class="white--text text-center blockchain-background"
        >
          <v-cols> </v-cols>
          <v-col cols="12"><h2 class="text-h3 mt-16">Blockchain</h2></v-col>
          <v-col> </v-col>
          <v-col cols="12">
            <v-row justify="center">
              <p class="text-h5 mt-3" style="max-width:900px">
                The Blockchain enables us to create new ecomic systems in
                unpresedented ways. We can create cryptographic currencies and
                decouple them from the current financial system. Because all
                financial transactions are stored on a public ledger the
                blockchain enforces transparency which is a key for creating a
                fair financial system. Through programatic contracts ( so called
                smart contracts) we can automize the value distribution, create
                new voting systems and reward individual actions that are the
                most benificial for all.
              </p>
            </v-row>
          </v-col>
        </v-row>
      </v-container> -->
      <!-- <v-container>
        <v-row style="margin-top:170px">
          <v-col class="white--text text-h4 text-center mt-16">
            Want To See More? <br />
            Check Our Portfolio <br />
            And Current Projects
          </v-col>
          <v-col cols="12">
            <ButtonWithFrame long to="Portfolio">Portfolio</ButtonWithFrame>
          </v-col>
        </v-row>
        <v-row justify="center" class="mt-n1">
          <v-img src="/images/background-spatial.jpg" class="mt-n2"></v-img>
        </v-row>
      </v-container> -->
      <!-- <v-container>
        <v-row class="mt-16">
          <v-col cols="12" class="white--text text-h3 text-center mt-16">
            Our Other Projects
          </v-col>
          <v-row class="mt-16">
            <v-col cols="6" class="mt-n5">
              <v-row justify="end">
                <v-img
                  src="@/assets/worldtree-logo.png"
                  max-width="500px"
                ></v-img>
              </v-row>
            </v-col>
            <v-col cols="6">
              <v-row justify="start">
                <div style="max-width:600px;">
                  <h2 class="text-h4 white--text mt-16">
                    The World Tree Visioning Platform
                  </h2>
                  <p class="white--text text-h5">
                    A cross platform project centric social network that is
                    build on top of the next generation internet. Incorporating
                    spatial web and web blockchain technology to empower
                    creators, architects, inventors, artists, startups and
                    communities.
                  </p>
                </div>
              </v-row>
            </v-col>
          </v-row>
          <v-col cols="6" class="mt-4">
            <v-row justify="end">
              <div style="max-width:600px;">
                <h2 class="text-h4 white--text text-right">
                  The Emplant - A Plant Biosynth
                </h2>
                <p class="white--text text-h5 text-right">
                  The emplant is a sensor based device that gives a voice to
                  your plants. It measures fine electrical current changes
                  inside a plant that is attached to the device via sensor
                  cables. In the future this projects aims to create new ways of
                  studying human plant interractions and create advancements in
                  agriculture
                </p>
              </div>
            </v-row>
          </v-col>
          <v-col cols="6">
            <v-row justify="start">
              <v-img
                src="@/assets/emplant.jpg"
                max-width="500px"
                style="border-radius:50px;"
                class="ml-10"
              ></v-img>
            </v-row>
          </v-col>
        </v-row>
      </v-container> -->
      <!-- <v-row style="margin-top:150px">
        <v-col cols="12" class="white--text text-h3 text-center mt-16">
          Our Partners
        </v-col>
        <v-col cols="6">
          <v-row justify="end">
            <v-img
              src="@/assets/dacore.png"
              :max-width="parnersImageWith"
              class="mr-3"
            ></v-img>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row justify="start">
            <v-img
              src="@/assets/resourceful.png"
              :max-width="parnersImageWith"
              class="ml-3 mt-1"
            ></v-img>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row justify="end">
            <v-img
              src="@/assets/gaya_net.png"
              max-width="200px"
              class="mr-10"
            ></v-img>
          </v-row>
        </v-col>
        <v-col cols="6">
          <v-row justify="start">
            <v-img
              src="@/assets/ebs_logo.png"
              max-width="200px"
              class="ml-10"
            ></v-img>
          </v-row>
        </v-col>
      </v-row> -->
      <!-- <v-container style="margin-top:180px" class="team pb-10">
        <v-row class="mt-16">
          <v-col cols="12" class="white--text text-h2 pt-5 text-center">
            Our Team
          </v-col>
        </v-row>
        <v-row justify="space-around" class="mb-5 mt-5">
          <v-col
            cols="4"
            v-for="person in team.slice(0, 2)"
            :key="person.name"
            class="mt-6"
          >
            <v-card class="text-center team-cards ma-3">
              <v-card-text>
                <v-avatar class="ma-6" size="120">
                  <v-img :src="`/images/${person.avatar}`"></v-img>
                </v-avatar>
                <div class="text-h5 white--text">{{ person.name }}</div>
                <div class="white--text text-body-1">{{ person.role }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="my-5">
          <v-col cols="4" v-for="person in team.slice(2, 5)" :key="person.name">
            <v-card class="text-center team-cards ma-3">
              <v-card-text>
                <v-avatar class="ma-6" size="120">
                  <v-img :src="`/images/${person.avatar}`"></v-img>
                </v-avatar>
                <div class="text-h5 white--text">{{ person.name }}</div>
                <div class="white--text text-body-1">{{ person.role }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container> -->
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import ButtonWithFrame from '@/components/ButtonWithFrame.vue'
export default {
  components: {
    ButtonWithFrame
  },
  data() {
    return {
      parnersImageWith: '300px',
      team: [
        {
          name: 'Mark Lee',
          role: 'Creative Director',
          avatar: 'mark.jpg'
        },
        {
          name: 'Sebastan Grede',
          role: 'Technical Director',
          avatar: 'sebastian.jpg'
        },
        {
          name: 'Zak Human',
          role: 'Video Production',
          avatar: 'zak.jpg'
        },
        {
          name: 'Zach Krausnick',
          role: 'Native VR And AR Development',
          avatar: 'zach.jpg'
        },
        {
          name: 'Tav Keen',
          role: 'Business Relations',
          avatar: 'tav.jpg'
        }
      ]
    }
  }
}
</script>

<style scoped>
.text-h2,
.text-h3,
.text-h4,
.text-body-2,
.text-body-1 {
  font-family: 'Overlock' !important;
  text-shadow: 0px 0px 24px rgba(255, 255, 255, 0.88);
}

.text-h5,
.text-h6 {
  font-family: 'Overlock' !important;
  /* line-height: 1.5rem !important; */
}

.welcome-background {
  margin-top: -48px;
  height: 100vh;
  width: 100vw;
  background: url('/images/pillbottle-background.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* position: absolute; */
  /* top: -48px; */
  /* left: 0; */
}

.blockchain-background {
  background: url('/images/blockchain-background.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.background-spatial {
  background: url('/images/background-spatial.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.team {
  /* display: block;
  width: 350px;
  height: 350px;
  margin: 50px auto 0; */
  border-radius: 70%;
  background: radial-gradient(
    circle at 50% 40%,
    white 1px,
    rgb(35, 72, 81) 3%,
    rgb(0, 0, 0) 60%,
    #01000a 100%
  );
}

.team-cards {
  background: linear-gradient(
    120deg,
    rgba(11, 35, 56, 0.904) 40%,
    rgba(43, 86, 92, 0.897) 100%
  );
}

.team-cards-2 {
  background: linear-gradient(
    200deg,
    rgba(11, 35, 56, 0.904) 40%,
    rgba(43, 86, 92, 0.897) 100%
  );
}
</style>
